import React, { FC } from 'react';

import { Container, Text } from '@lglp/components';
import {
  IconCardsContainer,
  IconCardsContainerTile,
} from '@lglp/prismic-client';

import Arrow from '../../../Icons/Arrow';
import ICONS from '../../../Icons/icons';
import { LinkedComponent } from '../../../LinkedComponent';
import styles from './IconCardsContainer.module.scss';

const IconCardsContainerTileComponent: FC<IconCardsContainerTileComponentProps> =
  ({ tile }) => {
    const { title, description, ctaLabel, ctaLink, icon } = tile;
    const Icon = ICONS[icon];

    return (
      <Container className={[styles.card, 'animate-svg']}>
        <LinkedComponent className={styles.linkCard} link={ctaLink}>
          {Icon && <Icon className={styles.icon} />}
          <Container className={styles.textIcon}>
            <Text className={styles.title} body={title} />
            <Text className={styles.description} body={description} />
            <Container className={styles.ctaContainer}>
              <Text className={styles.ctaLabel} body={ctaLabel} />
              <Arrow className={styles.arrow} />
            </Container>
          </Container>
        </LinkedComponent>
      </Container>
    );
  };

type IconCardsContainerTileComponentProps = {
  tile: IconCardsContainerTile;
};

export const IconCardsContainerSlice: FC<IconCardsContainerProps> = ({
  data,
  className,
}) => {
  const { tiles } = data;
  return (
    <Container className={[styles.container, className]}>
      {tiles &&
        tiles.map((tile, key) => (
          <IconCardsContainerTileComponent tile={tile} key={key} />
        ))}
    </Container>
  );
};

type IconCardsContainerProps = {
  data: IconCardsContainer;
  className?: string;
};
